module.exports = __webpack_public_path__ + "4ff0d87e946da0667c914033b157f7aa.svg";